"use client";
import Image from "next/image";
import Button from "./Cards/Button";
import { buttonsBlogPage } from "@/utils";

export default function BlogPageRicoComponent() {
    return (
        <div className=" container px-3 lg:max-w-[70rem] mx-auto  justify-center lg:flex">
            <div className="bg-lightGray rounded-md">
                <div className="flex  justify-between p-5">
                    <div className="lg:w-[800px] space-y-3 text-neutral-800 text-5xl font-bold font-['Baton Turbo Web'] leading-[48px]">
                        Innerlich stark und intakt, vollkommen gelassen:
                        <br />
                        für alle, die im Kern stabil sein wollen.
                        <div className="lg:flex lg:space-x-4">
                            {buttonsBlogPage.map((button) => (
                                <Button
                                    as="a"
                                    href={button.url}
                                    backgroundColor={button.backgroundColor}
                                    text={button.text}
                                    textColor={button.textColor}
                                    border={button.border}
                                    key={button.text}
                                    paddings={button.paddings}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Image
                alt="Rico's profile picture"
                src={"/images/ricoSmall.png"}
                height={500}
                width={500}
                className="text-center rounded-b-md  lg:rounded-r-md lg:rounded-bl-none"
            />
        </div>
    );
}
